<template>
  <company-register/>
</template>

<script>
import CompanyRegister from '../components/CompanyRegister/index'
export default {
  components: {CompanyRegister},

}
</script>

<style>

</style>
